import * as React from "react";
import {
  LineShareButton,
  LineIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  XIcon,
} from "react-share";
import { Box } from "@material-ui/core";
import { useLocation } from "@reach/router";

export default function SNS() {
  const location = useLocation();
  const shareUrl = location.href;

  return (
    <Box display="flex">
      <Box m={1}>
        <FacebookShareButton url={shareUrl} className="mr-2">
          <FacebookIcon size={40} round />
        </FacebookShareButton>
      </Box>
      <Box m={1}>
        <TwitterShareButton url={shareUrl} className="mr-2">
          <XIcon size={40} round />
        </TwitterShareButton>
      </Box>
      <Box m={1}>
        <LineShareButton url={shareUrl} className="mr-2">
          <LineIcon size={40} round />
        </LineShareButton>
      </Box>
    </Box>
  );
}
